import type { Insurance } from '@optionway/models';
import type { TagPlanEcommerce } from '#imports';

// Price carries no currency field and currencyRate is always 1, so the transaction currency is a constant.
export const TAG_PLAN_CURRENCY = 'EUR';

// Declining is not a cart line.
export const isCartInsurance = (insurance?: Insurance): insurance is Insurance =>
  insurance !== undefined && insurance.type !== 'NONE';

export const insuranceEcommerce = (insurance?: Insurance): TagPlanEcommerce | undefined => {
  if (!isCartInsurance(insurance)) {
    return;
  }
  return { currency: TAG_PLAN_CURRENCY, value: insurance.price.total, items: [insuranceTagPlanItem(insurance)] };
};
